var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "order-return-summary flex flex-auto flex-col",
    },
    [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n    Return #" + _vm._s(_vm.returnId) + " has been created.\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.needsReturnLabel || _vm.needsReturnLabel === null
        ? _c("div", { staticClass: "description description-title-fix" }, [
            _vm._v(
              "\n    Return label has been generated and sent to the customer."
            ),
            _c("br"),
            _vm._v(
              "\n    Once the devices are received by Ring, funds will be returned by the "
            ),
            _c("br"),
            _vm._v("\n    original payment method.\n  "),
          ])
        : _c("div", { staticClass: "description description-no-label" }, [
            _vm._v(
              "\n    The customer does not need to return the product(s), therefore no return label will be sent.\n  "
            ),
          ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "el-card",
        { attrs: { shadow: "never", "body-style": "margin: 0px !important;" } },
        [
          _c(
            "el-table",
            {
              staticClass: "table-hover",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.summary,
                "show-header": false,
                "row-class-name": "table-hover",
                "cell-class-name": "table-hover",
                "highlight-current-row": false,
              },
            },
            [
              _c(
                "el-table-column",
                { attrs: { type: "expand" } },
                [
                  [
                    _c("div", { staticClass: "return-details" }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-col" },
                        [
                          _c("div", { staticClass: "summary-header" }, [
                            _vm._v("\n                Items\n              "),
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _vm._l(_vm.itemsToReturn, function (item, idx) {
                            return _c(
                              "div",
                              _vm._b({ key: idx }, "div", item, false),
                              [
                                _vm._v(
                                  "\n                x" +
                                    _vm._s(item.quantity) +
                                    " " +
                                    _vm._s(item.title)
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticStyle: {
                                      color: "#6E6E6E",
                                      margin: "0 !important",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  ASIN: " +
                                        _vm._s(item.sku) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Customer info\n                "
                              ),
                            ]),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Name\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.customer.customer_name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Phone Number\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.customer.customer_phone)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Email\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.customer.customer_email)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "flex flex-row",
                                staticStyle: { "margin-top": "20px" },
                              },
                              [
                                _c("div", { staticClass: "flex-1" }, [
                                  _vm._v(
                                    "\n                    Street\n                  "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _vm._v(
                                    _vm._s(_vm.address.address_1) +
                                      " " +
                                      _vm._s(_vm.address.address_2)
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    City\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.city))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    State/province/area\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.state))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Zip code\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.zip))]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Country\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [_vm._v(_vm._s(_vm.address.country))]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("el-divider"),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "summary-header" }, [
                              _vm._v(
                                "\n                  Payments\n                "
                              ),
                            ]),
                            _c("br"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "flex flex-col" }, [
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Amount\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.refundInfo.amount)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-row" }, [
                              _c("div", { staticClass: "flex-1" }, [
                                _vm._v(
                                  "\n                    Currency\n                  "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _vm._v(_vm._s(_vm.refundInfo.currency)),
                              ]),
                            ]),
                          ]),
                        ],
                        2
                      ),
                    ]),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "Return details", prop: "title" },
              }),
              _c("label", [_vm._v("Return Details\n          ")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }